import React, { Component } from 'react'
import OutpatientAppointment from './components/index'

class AppointmentShare extends Component {
  render() {
    return (
      <div>
        <OutpatientAppointment {...this.props} />
      </div>
    )
  }
}

export default AppointmentShare



// WEBPACK FOOTER //
// ./src/modules/appointment/index.js